import styled from 'styled-components'

import { navTileWidth } from '../../../nav/NavTile/styles'
import { sidePad } from '../../../nav/NavTray/styles'

export const Wrapper = styled.div<{ groupSize: number }>`
  display: flex;
  max-width: calc((${navTileWidth} + (2 * ${sidePad})) * ${o => o.groupSize});
`
